import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackgroundContainer from "../../../components/BackgroundContainer/BackgroundContainer";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Input,
  Box,
  Typography,
} from "@mui/material";
import "./styleRelatorio.css";
import api from "../../../servicos/api";
import SelectSetor from "../components/setores";
import SelectUnidade from "../components/unidade";
import logo from "../../../assets/images/logo-dna-center.png";

export default function Relatorio() {
  const [arquivoLista, setArquivoLista] = useState([]);
  const [acontecendo, setAcontecendo] = useState("");
  const [ehFuncionario, setEhFuncionario] = useState("");
  const [unidadeId, setUnidadeId] = useState("");
  const [setorId, setSetorId] = useState("");
  const [qmPresenciou, setQmPresenciou] = useState("");
  const [qmCometeu, setQmCometeu] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [anonimo, setAnonimo] = useState("");
  const [qtTempo, setQtTempo] = useState("");
  const navigate = useNavigate();
  const [tipoDenuncia, setTipoDenuncia] = useState("");
  const [tipoDenunciaOutro, setTipoDenunciaOutro] = useState("");
  const [testemunhas, setTestemunhas] = useState("");
  const [dataOcorrido, setDataOcorrido] = useState("");
  const [descricaoEvidencias, setDescricaoEvidencias] = useState("");
  const [comunicouAlguem, setComunicouAlguem] = useState("");
  const [detalhesComunicacao, setDetalhesComunicacao] = useState("");
  const [desejaRetorno, setDesejaRetorno] = useState("");

  const scrollToTop = () => window.scrollTo(0, 0);

  const telefoneMascara = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d)(\d{4})$/, "$1-$2");
    return value;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      formData.append("acontecendo", acontecendo);
      formData.append("ehFuncionario", ehFuncionario === "true");
      formData.append("unidadeId", unidadeId);
      formData.append("setorId", setorId);
      formData.append("qmPresenciou", qmPresenciou);
      formData.append("qmCometeu", qmCometeu);
      formData.append("qtTempo", qtTempo);
      formData.append("nome", nome);
      formData.append("celular", celular);
      formData.append("email", email);
      formData.append("anonimo", anonimo === "true");
      formData.append("tipoDenuncia", tipoDenuncia);
      formData.append("tipoDenunciaOutro", tipoDenunciaOutro);
      formData.append("testemunhas", testemunhas);
      formData.append("dataOcorrido", dataOcorrido);
      formData.append("descricaoEvidencias", descricaoEvidencias);
      formData.append("comunicouAlguem", comunicouAlguem);
      formData.append("detalhesComunicacao", detalhesComunicacao);
      formData.append("desejaRetorno", desejaRetorno);

      Array.from(arquivoLista).forEach((f) => formData.append("provas", f));

      const reqpost = await api.post("/v2/gestaoEtica/denuncia", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const protocoloGerado = reqpost.data.data.protocolo;
      const idGerado = reqpost.data.data.id;

      navigate("/canaldaetica/relatorio/confirmacao", {
        state: {
          id: idGerado,
          protocolo: protocoloGerado,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <BackgroundContainer>
      <div className="all-page">
        <header className="cabecalho">
          <Grid item xs={12}>
            <Box
              mt={2}
              component="header"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "0px 0px 10px 10px",
                padding: 2,
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Logo DNA Center"
                sx={{
                  height: 70,
                  position: "absolute",
                  left: 16,
                }}
              />
              <Typography
                variant="h4"
                sx={{ color: "#232424", fontWeight: "bold" }}
              >
                Cadastro de denúncia
              </Typography>
            </Box>
          </Grid>
        </header>
        <main className="principal-rel">
          <form onSubmit={handleSubmit}>
            <Grid container direction="column" spacing={2}>
              {/* Nome */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setNome(e.target.value)}
                  fullWidth
                  variant="outlined"
                  label="Nome"
                  id="nome"
                />
              </Grid>

              {/* Trabalha no DNA Center */}
              <Grid item xs={12}>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={12} sm={12} md={4}>
                    <FormControl fullWidth required variant="outlined">
                      <InputLabel id="select-trabalha-label">
                        Você trabalha no DNA Center?
                      </InputLabel>
                      <Select
                        required
                        labelId="select-trabalha-label"
                        value={ehFuncionario}
                        onChange={(e) => setEhFuncionario(e.target.value)}
                        label="Você trabalha no DNA Center?"
                      >
                        <MenuItem value="true">Sim</MenuItem>
                        <MenuItem value="false">Não</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Setor */}
                  <Grid item xs={12} sm={12} md={4}>
                    <SelectSetor
                      onChange={(e) => setSetorId(e.target.value)}
                      value={setorId}
                    />
                  </Grid>

                  {/* Unidade */}
                  <Grid item xs={12} sm={12} md={4}>
                    <SelectUnidade
                      onChange={(e) => setUnidadeId(e.target.value)}
                      value={unidadeId}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Quem presenciou */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setQmPresenciou(e.target.value)}
                  required
                  fullWidth
                  variant="outlined"
                  label="Quem presencia ou presenciou?"
                  id="qmPresenciou"
                />
              </Grid>

              {/* Quem cometeu */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setQmCometeu(e.target.value)}
                  required
                  fullWidth
                  variant="outlined"
                  label="Quem comete ou cometeu?"
                  id="qmCometeu"
                />
              </Grid>

              {/* Tempo */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setQtTempo(e.target.value)}
                  required
                  fullWidth
                  variant="outlined"
                  label="Há quanto tempo isso vem acontecendo?"
                  id="qtTempo"
                />
              </Grid>

              {/* Upload de arquivos */}
              <Grid item xs={12}>
                <Input
                  type="file"
                  inputProps={{
                    multiple: true,
                    accept:
                      "application/pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpg, image/jpeg",
                  }}
                  color="primary"
                  onChange={(e) => {
                    setArquivoLista(e.target.files);
                  }}
                  // {...register("acontecendo", { required: true })}
                >
                  Anexar arquivoLista
                </Input>
              </Grid>

              {/* Tipo de denúncia */}
              <Grid item xs={12}>
                <FormControl fullWidth required variant="outlined">
                  <InputLabel id="tipo-denuncia-label">
                    Tipo de denúncia
                  </InputLabel>
                  <Select
                    labelId="tipo-denuncia-label"
                    value={tipoDenuncia}
                    onChange={(e) => setTipoDenuncia(e.target.value)}
                    label="Tipo de denúncia"
                  >
                    <MenuItem value="Assédio moral">Assédio moral</MenuItem>
                    <MenuItem value="Assédio sexual">Assédio sexual</MenuItem>
                    <MenuItem value="Corrupção">Corrupção</MenuItem>
                    <MenuItem value="Fraude">Fraude</MenuItem>
                    <MenuItem value="Irregularidades administrativas">
                      Irregularidades administrativas
                    </MenuItem>
                    <MenuItem value="Discriminação">Discriminação</MenuItem>
                    <MenuItem value="Outros">Outros</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Especifique outro tipo */}
              {tipoDenuncia === "Outros" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Especifique o tipo de denúncia"
                    value={tipoDenunciaOutro}
                    onChange={(e) => setTipoDenunciaOutro(e.target.value)}
                    id="tipoDenunciaOutro"
                  />
                </Grid>
              )}

              {/* Descrição dos acontecimentos */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setAcontecendo(e.target.value)}
                  required
                  fullWidth
                  variant="outlined"
                  label="Descreva os fatos"
                  multiline
                  rows={5}
                  id="acontecendo"
                />
              </Grid>

              {/* Data do ocorrido */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setDataOcorrido(e.target.value)}
                  fullWidth
                  variant="outlined"
                  label="Data ou período do ocorrido *"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  id="dataOcorrido"
                  required
                />
              </Grid>

              {/* Descrição das evidências */}
              <Grid item xs={12}>
                <TextField
                  onChange={(e) => setDescricaoEvidencias(e.target.value)}
                  fullWidth
                  variant="outlined"
                  label="Descrição das evidências"
                  multiline
                  rows={4}
                  id="descricaoEvidencias"
                />
              </Grid>

              {/* Já comunicou alguém? */}
              <Grid item xs={12}>
                <FormControl fullWidth required variant="outlined">
                  <InputLabel id="comunicou-label">
                    Já comunicou alguém?
                  </InputLabel>
                  <Select
                    labelId="comunicou-label"
                    value={comunicouAlguem}
                    onChange={(e) => setComunicouAlguem(e.target.value)}
                    label="Já comunicou alguém?"
                  >
                    <MenuItem value="true">Sim</MenuItem>
                    <MenuItem value="false">Não</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Detalhes da comunicação */}
              {comunicouAlguem === "true" && (
                <Grid item xs={12}>
                  <TextField
                    onChange={(e) => setDetalhesComunicacao(e.target.value)}
                    fullWidth
                    variant="outlined"
                    label="Para quem comunicou?"
                    id="detalhesComunicacao"
                    required={comunicouAlguem === "true"}
                  />
                </Grid>
              )}

              {/* Deseja retorno */}
              <Grid item xs={12}>
                <FormControl fullWidth required variant="outlined">
                  <InputLabel id="deseja-retorno-label">
                    Deseja retorno?
                  </InputLabel>
                  <Select
                    labelId="deseja-retorno-label"
                    value={desejaRetorno}
                    onChange={(e) => setDesejaRetorno(e.target.value)}
                    label="Deseja retorno?"
                  >
                    <MenuItem value="true">Sim</MenuItem>
                    <MenuItem value="false">Não</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* E-mail */}
              {desejaRetorno === "true" && (
                <Grid item xs={12}>
                  <TextField
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    variant="outlined"
                    label="E-mail"
                    type="email"
                    id="email"
                    required={desejaRetorno === "true"}
                  />
                </Grid>
              )}
              {/* Celular */}
              {desejaRetorno === "true" && (
                <Grid item xs={12}>
                  <TextField
                    value={celular}
                    onChange={(e) =>
                      setCelular(telefoneMascara(e.target.value))
                    }
                    fullWidth
                    variant="outlined"
                    label="Celular"
                    inputProps={{ maxLength: 15 }}
                    id="celular"
                    required={desejaRetorno === "true"}
                  />
                </Grid>
              )}
              {/* Anônimo */}
              <Grid item xs={12}>
                <FormControl fullWidth required variant="outlined">
                  <InputLabel id="anonimo-label">
                    Deseja ser anônimo?
                  </InputLabel>
                  <Select
                    labelId="anonimo-label"
                    value={anonimo}
                    onChange={(e) => setAnonimo(e.target.value)}
                    label="Deseja ser anônimo?"
                  >
                    <MenuItem value="true">Sim</MenuItem>
                    <MenuItem value="false">Não</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Botões */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  Enviar denúncia
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  component={Link}
                  to="/canaldaetica"
                  fullWidth
                  variant="outlined"
                  color="secondary"
                >
                  Voltar
                </Button>
              </Grid>
            </Grid>
          </form>
        </main>
      </div>
    </BackgroundContainer>
  );
}
